import { EligibleProductsLimitUpdated } from '@api';
import { Paper } from '@mui/material';
import { LabelGroup, LabeledValue } from '@tsp-ui/core/components';

import styles from './EligibleProductsLimitCard.module.scss';


interface EligibleProductsLimitCardProps {
    config: EligibleProductsLimitUpdated;
}

export default function EligibleProductsLimitCard({ config }: EligibleProductsLimitCardProps) {
    const { name } = config;

    return (
        <Paper
            variant="outlined"
            className={styles.root}
        >
            <LabelGroup title={name}>
                <LabeledValue
                    label="Limit amount:"
                    value="TODO"
                />

                <LabeledValue
                    label="Expiration date:"
                    value="TODO"
                />
            </LabelGroup>
        </Paper>
    );
}
